export default __webpack_public_path__ + "cf3a1d1505cba44dc811021452088312.jpg";